import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ADDITIONAL_FLOWS, CoreModuleModule, Flow } from '@nexato/nx-core-module';
import { LightgalleryModule } from 'lightgallery/angular';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from '../app-routing.module';
import { FrontendMaterialModule } from '../material-module/material.module';
import { SharedModule } from '../shared-module/shared.module';
import { CommentDialogComponent } from './components/comment-dialog/comment-dialog.component';
import { LinkedTasksListViewComponent } from './components/linked-tasks-view/linked-tasks-list-view.component';
import { OrderOperatedRentalDetailsComponent } from './components/order-operated-rental-details/order-operated-rental-details.component';
import { OrderOperatedRentalLineItemsComponent } from './components/order-operated-rental-line-items/order-operated-rental-line-items.component';
import { OrderOperatedRentalProtocolsViewComponent } from './components/order-operated-rental-protocols-view/order-operated-rental-protocols-view.component';
import { OrderOperatedRentalTaskListProtocolViewComponent } from './components/order-operated-rental-task-list-protocol-view/order-operated-rental-task-list-protocol-view.component';
import { OrderOperatedRentalTaskListViewComponent } from './components/order-operated-rental-task-list-view/order-operated-rental-task-list-view.component';
import { OrderRentDetailsComponent } from './components/order-rent-details/order-rent-details.component';
import { OrderRentHeaderComponent } from './components/order-rent-header/order-rent-header.component';
import { OrderRentLineItemsComponent } from './components/order-rent-line-items/order-rent-line-items.component';
import { OrderRentProtocolsViewComponent } from './components/order-rent-protocols-view/order-rent-protocols-view.component';
import { OrderRentResourceAssignmentProtocolsViewComponent } from './components/order-rent-resourceAssignment-protocols-view/order-rent-resourceAssignment-protocols-view.component';
import { OrderServiceHeaderComponent } from './components/order-service-header/order-service-header.component';
import { OrderTaskListViewComponent } from './components/order-task-list-view/order-task-list-view.component';
import { OperatedRentalOrderCopyPublicLinkCommandCustomFlow } from './containers/order-view/custom-flows/operatedRentalOrderCopyPublicLinkCommandCustomFlow';
import { OperatedRentalOrderCreatePDFCommandCustomFlow } from './containers/order-view/custom-flows/operatedRentalOrderCreatePDFCommandCustomFlow';
import { RentalOrderCopyPublicLinkCommandCustomFlow } from './containers/order-view/custom-flows/rentalOrderCopyPublicLinkCommandCustomFlow';
import { RentalOrderCreatePDFCommandCustomFlow } from './containers/order-view/custom-flows/rentalOrderCreatePDFCommandCustomFlow';
import { OrderViewComponent } from './containers/order-view/order-view.component';
import { OrdersListComponent } from './containers/orders-list/orders-list.component';
import { OrderService } from './shared/services/order/order.service';
@NgModule({
  declarations: [
    OrdersListComponent,
    OrderViewComponent,
    OrderTaskListViewComponent,
    OrderRentHeaderComponent,
    OrderServiceHeaderComponent,
    OrderRentDetailsComponent,
    OrderRentLineItemsComponent,
    OrderOperatedRentalLineItemsComponent,
    CommentDialogComponent,
    OrderRentProtocolsViewComponent,
    OrderRentResourceAssignmentProtocolsViewComponent,
    OrderOperatedRentalTaskListViewComponent,
    OrderOperatedRentalProtocolsViewComponent,
    OrderOperatedRentalDetailsComponent,
    LinkedTasksListViewComponent,
    OrderOperatedRentalTaskListProtocolViewComponent
  ],
  imports: [
    CommonModule,
    FrontendMaterialModule,
    AppRoutingModule,
    SharedModule,
    CoreModuleModule.forRoot(environment, [
      {
        provide: ADDITIONAL_FLOWS,
        multi: true,
        useFactory: (
          rentalOrderCreatePDFCommandCustomFlow: RentalOrderCreatePDFCommandCustomFlow,
          rentalOrderCopyPublicLinkCommandCustomFlow: RentalOrderCopyPublicLinkCommandCustomFlow,
          operatedRentalOrderCopyPublicLinkCommandCustomFlow: OperatedRentalOrderCopyPublicLinkCommandCustomFlow,
          operatedRentalOrderCreatePDFCommandCustomFlow: OperatedRentalOrderCreatePDFCommandCustomFlow
        ) => {
          const additionalFlows = new Map<string, Flow>();
          additionalFlows.set('rentalOrderCreatePDFCommandCustomFlow', rentalOrderCreatePDFCommandCustomFlow);
          additionalFlows.set('rentalOrderCopyPublicLinkCommandCustomFlow', rentalOrderCopyPublicLinkCommandCustomFlow);
          additionalFlows.set('operatedRentalOrderCopyPublicLinkCommandCustomFlow', operatedRentalOrderCopyPublicLinkCommandCustomFlow);
          additionalFlows.set('operatedRentalOrderCreatePDFCommandCustomFlow', operatedRentalOrderCreatePDFCommandCustomFlow);
          return additionalFlows;
        },
        deps: [
          RentalOrderCreatePDFCommandCustomFlow,
          RentalOrderCopyPublicLinkCommandCustomFlow,
          OperatedRentalOrderCopyPublicLinkCommandCustomFlow,
          OperatedRentalOrderCreatePDFCommandCustomFlow
        ]
      },
      // outcommented cause this is just an example in how to use this
      // {
      //   provide: ADDITIONAL_COMPLETION_BEHAVIORS, 
      //   useFactory: (
      //     rentalOrderTestCommandCustomCompletionBehavior: RentalOrderTestCommandCustomCompletionBehavior
      //   ) => {
      //     const additionalCompletionsBehaviors = new Map<string, CompletionBehavior>();
      //     // this is just an example on how to use this
      //     // additionalCompletionsBehaviors.set('rentalOrderTestCommandCustomCompletionBehavior', rentalOrderTestCommandCustomCompletionBehavior);
      //     return additionalCompletionsBehaviors;
      //   },
      //   deps: [
      //     RentalOrderTestCommandCustomCompletionBehavior
      //   ]
      // }
    ]),
    ReactiveFormsModule,
    FormsModule,
    LightgalleryModule,
    ClipboardModule,
    TabViewModule,
    TableModule,
    DropdownModule,
    TagModule,
    MultiSelectModule,
    AccordionModule,
    PaginatorModule
  ],
  providers: [
    OrderService,
  ],
  exports: [
    OrdersListComponent,
    OrderViewComponent,
    OrderTaskListViewComponent,
    OrderRentResourceAssignmentProtocolsViewComponent
  ]
})
export class OrderModule { }
